import { createContext } from 'react';

export interface RetentionSearchContextValue {
    query: string;
    submittedQuery: string;
    error: string;
    loading: boolean;
    setQuery: (value: string) => void;
    submit: () => void;
    /**
     * Vacía el buscador y descarta el cliente buscado.
     *
     * Lo usa la pestaña Transacciones, la única donde el correo NO es
     * obligatorio: sin cliente el listado pasa a mostrar la cartera del
     * comercial. El resto de las pestañas sigue exigiendo correo, así que no
     * ofrecen esta acción.
     */
    clearSearch: () => void;
}

export const RetentionSearchContext = createContext<RetentionSearchContextValue>({
    query: '',
    submittedQuery: '',
    error: '',
    loading: false,
    setQuery: () => {},
    submit: () => {},
    clearSearch: () => {},
});
